export default {
  services: {
    zh: '外部服务',
    en: 'External Services',
  },
  registerService: {
    zh: '注册外部服务',
    en: 'Register external service',
  },
  serviceDetail: {
    zh: '服务详情',
    en: 'Service Detail',
  },
  functions: {
    zh: '外部函数列表',
    en: 'External Functions',
  },
  funcName: {
    zh: '函数名称',
    en: 'Function Name',
  },
  funcTip: {
    zh: '外部函数通过注册外部服务配置的方式，将已有的服务映射成 eKuiper SQL 函数。运行使用外部函数的规则时，eKuiper 将根据配置，对数据输入输出进行转换，并调用对应的服务。',
    en: 'External functions map existing services to eKuiper SQL functions through configuration. When running the rules that use external functions, eKuiper will convert data input and output according to the configuration, and call the corresponding service.',
  },
}
